import { render } from "./WalletSelectModal.vue?vue&type=template&id=2e4fe9e2&scoped=true&ts=true"
import script from "./WalletSelectModal.vue?vue&type=script&lang=ts"
export * from "./WalletSelectModal.vue?vue&type=script&lang=ts"

import "./WalletSelectModal.vue?vue&type=style&index=0&id=2e4fe9e2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4fe9e2"]])

export default __exports__